import React from 'react'
import ButtonGroup from '../../../../Components/ButtonGroup/ButtonGroup';
import Dropdown from '../../../../Components/Dropdown/Dropdown';
import { Button, Input } from '../../../../Components/StyledComponents';
import { convertCost } from '../../../../Utils/functions';
import './SetTarget.scss';

const targetName = {
    PointCount : '적립횟수 많은순',
    LastVisit : '최근 방문일 순',
    Point : '보유 포인트 순'
}

const SetTarget = ({gender,setGender, age,setAge,targetSort,setTargetSort, reqCount,setReqCount,getTarget, targetCount}) => {
    //상세 타겟 성별 handler
    const handleTargetGender = (val) => {
        let index = gender.indexOf(val)
        
        if( index === -1) setGender( old => [...old, val])
        else setGender( old => old.filter((data) => data !== val))
    }
    
    //상세 타겟 연령 handler
    const handleTargetAge = (val) => {
        let index = age.indexOf(val)
        
        if( index === -1) setAge( old => [...old, val])
        else setAge( old => old.filter((data) => data !== val))
    }
    
    return (
        <div>
            <div className="box">
                <p className="title">상세 타겟 설정</p>
                <ButtonGroup
                    label="타겟 성별"
                    values={gender}
                    options={[
                        { label : '정보없음', value : 'Unknown'},
                        { label : '남성', value : 'Male'},
                        { label : '여성', value : 'Female'},
                    ]}
                    onClick={(val) => handleTargetGender(val)}
                />
                <ButtonGroup
                    style={{ marginTop : 40 }}
                    label="타겟 나이"
                    values={age}
                    options={[
                        { label : '정보없음', value : 'Unknown'},
                        { label : '10대', value : 10},
                        { label : '20대', value : 20},
                        { label : '30대', value : 30},
                        { label : '40대', value : 40},
                        { label : '50대', value : 50},
                        { label : '60대 이상', value : 60},
                    ]}
                    onClick={(val) => handleTargetAge(val)}
                />

                <div className="row" style={{ marginTop : 40 }}>
                    <p className="info-title">타겟 인원</p>
                    <Dropdown
                        width={156}
                        options={[
                            { key : '전체', value : ''},
                            { key : '적립횟수 많은순', value : 'PointCount'},
                            { key : '최근 방문일 순', value : 'LastVisit'},
                            { key : '보유 포인트 순', value : 'Point'}
                        ]}
                        value={targetSort === '' ? '전체' : targetName[targetSort]}
                        onItemClick={(val) => setTargetSort(val)}
                    />

                    <Input
                        style={{ width : 80, marginLeft : 24 }}
                        value={reqCount}
                        onChange={(e) => setReqCount(e.target.value)}
                    />
                    <p className="input-text">명</p>
                </div>
            </div>

            <div className="row filter-box">
                <p className="filter-title">현재 추출 타겟 : {convertCost(targetCount)}명</p>
                <button className='filter-btn' onClick={() => getTarget()}>
                    필터 적용하기
                </button>
            </div>
        </div>
    )
}

export default SetTarget;